<template>
  <div>
    <a-modal
      title="资源回收"
      :visible="visible"
      :mask-closable="false"
      :width="750"
      :confirm-loading="loading"
      destroy-on-close
      @cancel="handleCancel"
      @ok="handleOk('form')"
    >
      <a-form-model
        ref="form"
        :model="form"
        :rules="validateRules"
        label-align="right"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item
              label="基地"
              prop="baseId"
            >
              <a-select
                v-model="form.baseId"
                placeholder="请选择基地"
                allow-clear
                show-search
                :filter-option="filterOption"
                :disabled="isEdit? true: false"
                @select="selectBase()"
              >
                <a-select-option
                  v-for="item in baseOptions"
                  :key="item.baseId"
                >
                  {{ item.baseName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              label="产品类型:"
              prop="productTypeId"
            >
              <a-select
                v-model="form.productTypeId"
                placeholder="请选择产品类型"
                allow-clear
                :disabled="isEdit? true: false"
                show-search
                :filter-option="filterOption"
                @select="selectProduct"
              >
                <a-select-option
                  v-for="item in productTypetions"
                  :key="item.productTypeId"
                >
                  {{ item.productTypeName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <div v-if="visibleGrant">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item
                label="开通时间:"
                prop="openDate"
              >
                <a-range-picker
                  v-model="form.openDate"
                  :disabled="isEdit? true: false"
                  @change="onStartDate"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item
                label="外采金额"
                prop="externalProcurementAmount"
              >
                <a-input
                  v-model="form.externalProcurementAmount"
                  placeholder="请填写外采金额"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item
                label="已付款金额:"
                prop="amountPaid"
              >
                <a-input
                  v-model="form.amountPaid"
                  placeholder="请填写已付款金额"
                />
              </a-form-model-item>
            </a-col>
          </a-row>

          <div class="table">
            <a-table
              :data-source="dataSource"
              :loading="loading"
              :columns="columns"
              :pagination="false"
              :row-key="(item, index) => index"
              :row-selection="rowSelection"
              style="width: 100%;"
            >
              <template
                slot="startDate"
                slot-scope="startDate"
              >
                {{ moment(Number(startDate)).format('YYYY-MM-DD') }}
              </template>
            </a-table>
          </div>

          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item
                label="回收额度:"
                prop="recoveryAmount"
              >
                <a-input-number
                  v-model="form.recoveryAmount"
                  :min="0"
                  placeholder="请添加回收额度"
                  style="width: 100%;"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item
                label="回收时间:"
                prop="recoveryDate"
              >
                <a-date-picker
                  v-model="form.recoveryDate"
                  style="width: 100%;"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item
                label="备注:"
                prop="remark"
              >
                <a-input
                  v-model="form.remark"
                  placeholder="请添加备注"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { queryRecover, recoveryResource, updateRecoveryResource } from '@/api/flowDetail.js'
import moment from 'moment'
import {
  queryBases,
  queryProductTypeBySubsidy
} from '@/api/common.js'
import { dateChange, filterOption } from '@/utils/utils.js'

const columns = [
  {
    title: '开通时间',
    dataIndex: 'startDate',
    key: 'startDate',
    scopedSlots: { customRender: 'startDate' }
  },
  {
    title: '补贴金额',
    dataIndex: 'subsidyAmount',
    key: 'subsidyAmount'
  },
  {
    title: '企业名称',
    dataIndex: 'enterpriseName',
    key: 'enterpriseName'
  },
  {
    title: '代金券编码',
    dataIndex: 'voucherCode',
    key: 'voucherCode'
  },
  {
    title: '产品名称',
    dataIndex: 'productName',
    key: 'productName'
  },
  {
    title: '运营年度',
    dataIndex: 'operatorYear',
    key: 'operatorYear'
  }
]
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    initData: {
      type: Object,
      default: function () { return {} }
    }
  },
  data () {
    return {
      loadingGrant: false,
      visibleGrant: false,
      confirmLoadingGrant: false,
      productTypetions: [],
      baseOptions: [],
      form: {
        baseId: undefined,
        baseName: undefined,
        productTypeId: undefined,
        date: '',
        openDate: [],
        startDate: null,
        endDate: null,
        taxIncome: '',
        taxRate: '',
        remark: '',
        recoveryAmount: undefined,
        recoveryDate: null,
        resourceDistributionRecordId: undefined,
        externalProcurementAmount: null,
        amountPaid: null
      },
      subsidyId: '',
      columns,
      dataSource: [],
      distributionAmount: '',
      operatorAmout: '',
      remainAmount: '',
      validateRules: {
        baseId: [{ required: true, message: '请选择基地' }],
        productTypeId: [{ required: true, message: '请输入产品类型' }],
        recoveryDate: [{ required: true, message: '请选择回收时间' }],
        recoveryAmount: [{ required: true, message: '请选择回收额度' }],
        enterpriseName: [{ required: true, message: '请选择企业名称' }],
        startTime: [{ required: true, message: '请选择开通时间' }],
        endTime: [{ required: true, message: '请选择结束时间' }],
        resourceDistributionRecordId: [{ required: true, message: '请选择资源发放记录' }]
      },
      isSelectProduct: false,
      isSelectBase: false,
      startValue: null,
      endValue: null,
      endOpen: false,
      recoveredRecordId: undefined
    }
  },
  computed: {
    rowSelection () {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.form.resourceDistributionRecordId = selectedRows[0].recordId
        },
        getCheckboxProps: record => ({
          props: {
            disabled: this.isEdit, // Column configuration not to be checked
            name: record.name,
            defaultChecked: this.isEdit ? record.recordId === this.initData.recoveredRecordId : null
          }
        }),
        type: 'radio'
      }
    }
  },
  watch: {
    visible: {
      deep: true,
      handler: async function (data) {
        if (data) {
          this.initData.startDate = this.initData.startDate
            ? moment(this.initData.startDate)
            : null

          this.initData.endDate =
          this.initData.endDate
            ? moment(this.initData.endDate)
            : null

          this.initData.recoveryDate =
          this.initData.recoveryDate
            ? moment(this.initData.recoveryDate)
            : null

          Object.assign(this.form, this.initData)
          this.form.openDate = [this.initData.startDate, this.initData.endDate]

          if (this.isEdit) {
            this.visibleGrant = true
            this.form.recoveryAmount = Math.abs(this.initData.subsidyAmount)
            this.selectGrantResource(this.isSelectProduct, this.isSelectBase)
            this.selectGrantResource(this.form.baseId, this.form.productTypeId)
            // console.log(this.initData.recoveredRecordId)
            this.recoveredRecordId = this.initData.recoveredRecordId
            this.form.resourceDistributionRecordId = this.initData.recordId
          }
        }
      }
    }
  },
  mounted () {
    this.fetchOptions()
  },
  methods: {
    moment,
    dateChange,
    filterOption,
    handleCancel () {
      this.$refs.form.resetFields()
      this.$emit('cancel')
      this.visibleGrant = false
    },
    handleOk () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.resourceDistributionRecordId) {
            if (!this.isEdit) {
              recoveryResource({
                resourceDistributionRecordId: this.form.resourceDistributionRecordId,
                recoveryAmount: this.form.recoveryAmount,
                recoveryDate: this.dateChange(this.form.recoveryDate),
                remark: this.form.remark
              }).then(() => {
                this.$message.success('提交成功!')
                this.$emit('ok')
              })
            } else {
              updateRecoveryResource({
                resourceDistributionRecordId: this.recoveredRecordId,
                recoveryAmount: this.form.recoveryAmount,
                recoveryDate: this.dateChange(this.form.recoveryDate),
                remark: this.form.remark,
                recordId: this.form.recordId
              }).then(() => {
                this.$message.success('更新成功!')
                this.$emit('ok')
              })
            }
          } else {
            this.$message.error('未选中资源发放详情项，当前数据无法提交')
          }
        }
      })
    },
    fetchOptions () {
      queryBases().then((data) => {
        this.baseOptions = data
      })
      queryProductTypeBySubsidy({
        subsidyType: 2
      }).then((data) => {
        this.productTypetions = data
      })
    },
    selectBase () {
      this.isSelectBase = true
      this.selectGrantResource(this.isSelectProduct, this.isSelectBase)
      this.selectGrantResource(this.form.baseId, this.form.productTypeId)
    },
    selectProduct () {
      this.isSelectProduct = true
      this.selectGrantResource(this.isSelectProduct, this.isSelectBase)
      this.selectGrantResource(this.form.baseId, this.form.productTypeId)
    },
    async selectGrantResource (value1, value2) {
      if (value1 && value2) {
        this.isSelectBase = false
        this.isSelectProduct = false
        await queryRecover({
          baseId: this.form.baseId,
          productTypeId: this.form.productTypeId
        }).then((data) => {
          this.visibleGrant = true
          this.dataSource = data
        })
      }
    },
    async onStartDate (date, dateString) {
      this.form.startDate = this.dateChange(date[0])
      this.form.endDate = this.dateChange(date[1])
      await queryRecover({
        baseId: this.form.baseId,
        productTypeId: this.form.productTypeId,
        startTime: this.form.startDate,
        endTime: this.form.endDate
      }).then((data) => {
        this.visibleGrant = true
        this.dataSource = data
      })
    }
  }
}
</script>
<style lang="less" scoped>
.amountClass {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  .a-pad {
    margin: 20px 0 20px;
  }
}

.ant-modal-content {
  max-height: 650px;
  overflow-y: auto;
}

.ant-form-item {
  margin-bottom: 14px;
}

.a-start-padding {
  margin: 0 30px 0;
}
</style>
